module.exports = __webpack_public_path__ + "static/sistemas_escalable-4d0e395bc64618efae46cc40ea9e768f.png";